import { useQuery } from '@tanstack/react-query';
import { getCurrentUserProfile, type UserProfile } from '~/apis/userApi';

export const CURRENT_USER_PROFILE_QUERY_KEY = ['currentUserProfile'] as const;

export function useCurrentUserProfile(options?: { enabled?: boolean }) {
  return useQuery<UserProfile, Error>({
    queryKey: CURRENT_USER_PROFILE_QUERY_KEY,
    queryFn: getCurrentUserProfile,
    staleTime: 5 * 60 * 1000,
    enabled: options?.enabled ?? true,
  });
}
